import {RolesAdapter} from './roles-adapter.service';

export const Adapters = [RolesAdapter];
